<template>
  <div v-if="authenticated" id="account-feed">
    <b-container>
      <h2>{{ $t('account.followingsDescription') }}</h2>
      <div v-if="userFollowings && userFollowings.length > 0">
        <section class="social-activities">
          <div class="masonry">
            <div v-for="(post, index) in userFollowings"
                 :key="index"
                 class="masonry-brick">
              <a class="text-left d-block" :href="`/${post.slug}`" style="color: black;">
                <avatar class="d-inline-block mr-2" size="50px" :userImage="post.image" :userName="`${post.first_name} ${post.last_name}`"></avatar>
                <span class="d-inline"><strong>{{ post.first_name }} {{ post.last_name }}</strong></span>
                <hr />
              </a>
              <div v-if="!_.isUndefined(post.large)"
                   id="photos"
                   class="text-left mb-3">
                <a :href="post.link"
                   target="_blank"
                   class="photo d-block mb-3">
                  <img :src="post.large" />
                </a>
                <p>
                  {{ post.caption }}
                </p>
                <p align="center">
                  <b-btn variant="secondary"
                         :href="post.link"
                         target="_blank"
                         class="btn-instagram mx-auto">{{ $t('professional.social.instagram.viewBtn') }}</b-btn>
                </p>
                <hr />
              </div>
              <div v-else
                   id="posts"
                   class="text-left mb-3">
                <div>{{ frontEndDateFormat(post.created_time) }}</div>
                <hr />
                <strong>{{ post.message }}</strong>
                <hr />
                <p align="center">
                  <b-btn variant="secondary"
                         :href="`https://www.facebook.com/${post.id}`"
                         target="_blank"
                         class="btn-facebook mx-auto"><img height="20" src="@/assets/images/logo-fb.svg" />{{ $t('professional.social.facebook.viewBtn') }}</b-btn>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div v-else>
        <p v-html="$t('account.followingsEmpty')"></p>
        <b-btn variant="primary" :to="{ name: `Professionals.${$i18n.i18next.language}` }">{{ $t('buttons.browseProfessionals') }}</b-btn>
      </div>
    </b-container>
  </div>
  <div v-else>
    <b-alert variant="danger" show>
      {{ $t('account.accessDenied') }}
    </b-alert>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { frontEndDateFormat } from '@/util/date'

  /* Start of lazy load components config */
  import lazyLoadComponent from '@/util/lazy-load-component'
  import Preloader from '@/app/global/components/Preloader'
  // import SkeletonBox from '@/app/global/components/SkeletonBox'
  const lazyLoadOptions = {
    loading: Preloader,
    loadingData: {
      props: {
        width: '100%',
        height: '2rem'
      }
    }
  }
  /* End of lazy load components config */

  export default {
    name: 'account-feed',
    components: {
      Ratings: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/Ratings')})
    },
    data () {
      return {
        errors: []
      }
    },
    // metaInfo: {
    //   title: 'Test',
    //   titleTemplate: '%s - Yay!',
    //   htmlAttrs: {
    //     lang: 'en',
    //     amp: true
    //   }
    // },
    computed: {
      ...mapGetters({
        user: 'account/user',
        authenticated: 'account/authenticated',
        userFollowings: 'account/userFollowings'
      }),
    },
    methods: {
      ...mapActions({
        getFollowings: 'account/getFollowings'
      }),
      frontEndDateFormat: frontEndDateFormat,
    },
    mounted () {
      this.getFollowings({ context: this })
    },
    created () {
    },
    watch: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">


  .btn-instagram {
    color: white !important;
  }

  .social-activities {
    #photos {
      img {
        width: 100%;
        height: auto;
      }
    }

    #posts {
      .btn-facebook {
        color: white;
        background-color: #3c5a99;
        vertical-align: middle;

        img {
          margin-top: -0.2rem;
          margin-right: 0.5rem;
          vertical-align: middle;
        }
      }
    }
  }

  .masonry {
    display: flex;
    flex-flow: row wrap;
    padding: 0.5rem 0;
    margin-right: -1%;
  }

  .masonry-brick {
    flex: auto;
    height: auto;
    min-width: 150px;
    margin: 0 1% 1% 0; /* Some gutter */
    border: 1px solid #d0d0d0;
    padding: 1rem;

    img.uploaded-photo {
      width: 100%;
      height: auto;
      max-width: 400px;

      &.blur {
        -webkit-filter: blur(15px);
        filter: blur(15px);
        margin-bottom: 2rem;
      }
    }
  }
  .masonry-brick {
    &:nth-child(3n+1){
      width: 29%;
    }
    &:nth-child(3n+2){
      width: 29%;
    }
    &:nth-child(3n+3){
      width: 29%;
    }
    &:nth-child(4n+4){
      width: 29%;
    }

    @include media-breakpoint-down(md) {
      &:nth-child(4n+1){
        width: 49%;
      }
      &:nth-child(4n+2){
        width: 49%;
      }
      &:nth-child(4n+3){
        width: 49%;
      }
      &:nth-child(4n+4){
        width: 49%;
      }
    }

    @include media-breakpoint-down(sm) {
      &:nth-child(4n+1){
        width: 49%;
      }
      &:nth-child(4n+2){
        width: 49%;
      }
      &:nth-child(4n+3){
        width: 49%;
      }
      &:nth-child(4n+4){
        width: 49%;
      }
    }

    @include media-breakpoint-down(xs) {
      &:nth-child(4n+1){
        width: 100%;
      }
      &:nth-child(4n+2){
        width: 100%;
      }
      &:nth-child(4n+3){
        width: 100%;
      }
      &:nth-child(4n+4){
        width: 100%;
      }
    }
  }
</style>
